// StageId — canonical ingest pipeline stage ids (Sprint 19BH Day 1 Step 1.2 prereq).
//
// Sprint 19BH context: Several Day 1 / Day 3 / Day 4 schemas need to validate
// a `stage: StageId` field — ConceptOmission (which stage soft-escaped a
// concept), RegenScope (which stage to regenerate), GapEntry (which stage
// the audit gap was found in). Those schemas live in @examforge/shared, so
// the StageId Zod schema must also live here (shared cannot import from
// @examforge/ingest without breaking the dependency direction).
//
// SOURCE OF TRUTH: `packages/ingest/src/generate/stage-types.ts` STAGE_IDS const.
// This file is a DELIBERATE MIRROR — when a new stage is added in ingest, this
// enum must be updated in lockstep. 19BH Day 2 health-check adds a snapshot
// test (manifest invariants) that compares the two lists; mismatch = test fail
// with explicit "STAGE_IDS desync" message.
//
// Why duplicate instead of moving the type to shared:
//   - ingest stage-types.ts contains stage-execution machinery types
//     (SlotPayload / IngestRouter ref / LlmProvider ref) that have NO place
//     in shared (shared has no Cloudflare Workers / provider types).
//   - The DUPLICATION is only of the *id list* — the execution surface stays
//     in ingest. This is the smallest possible split.
//
// LLM_NATIVE_ARCHITECTURE compliance:
//   §2.1 provenance — `stage` field on items / omissions / gaps is *derived*
//                     (set by the pipeline, not by LLM); v4 strict enum
//                     prevents LLM from inventing stage names.
import { z } from 'zod';
/**
 * The canonical ordered list of ingest stage ids. Must stay in sync with
 * `packages/ingest/src/generate/stage-types.ts` STAGE_IDS.
 *
 * Adding a new stage:
 *   1. Add the id here.
 *   2. Add the id in ingest stage-types.ts STAGE_IDS (same order).
 *   3. (19BH Day 2) health-check snapshot test will guard the lockstep.
 */
export const STAGE_IDS = [
    'condense_per_kind',
    'bundle_past_papers',
    'extract_cases',
    'flashcards',
    'mcqs',
    'true_false',
    'essays',
    'mindmaps',
    'glossary',
    'lecture_notes',
    'proof_drills',
    'free_responses',
    'reading_passages',
    'mock_papers',
    'audit', // 19BH Day 3 — no-LLM audit script as a step.do
];
export const StageIdSchema = z.enum(STAGE_IDS);
export const ALL_STAGE_IDS = StageIdSchema.options;
//# sourceMappingURL=stage-id.js.map